<template>
  <div v-if="show" id="cookie-msg" class="cookie-msg" style="bottom: 0px;">
    Nós usamos cookies para melhorar o desempenho de nossos sites e oferecer uma
    experiência de navegação mais personalizada. Se você continuar a navegar
    neste site ou fechar esta mensagem sem modificar as definições do seu
    navegador, os cookies continuarão ativos.
    <a
      target="_blank"
      href="http://www.parana.pr.gov.br/Pagina/Informacoes-sobre-Cookies"
      class="0"
      rel="nofollow"
      >Saiba mais<span class="0"><span class="element-invisible"> </span></span
    ></a>
    sobre cookies e como alterar as configurações do seu computador, caso não
    concorde com a utilização deles.
    <b-row align-h="center" class="mt-2"><b-button variant="outline-info" @click="show = false"><i class="fas fa-times"></i> Entendi. Fechar este aviso.</b-button></b-row>
    <!-- <a href="#" class="fas fa-times" @click="show = false"> </a> -->
  </div>
</template>

<script>
export default {

  data () {
    return {
      show: true
    }
  }
}
</script>

<style>
#cookie-msg.cookie-msg {
  display: block;
  position: fixed;
  bottom: -100px;
  left: 0;
  padding: 25px;
  z-index: 9999;
  width: 100%;
  color: #333;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  background: rgba(255,255,255, .9);
  font-size: 13px;
  border-top: 1px solid #666;
}
</style>
